import { DataFormats } from '@skylab-shared/constants';
import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE } from '@skylab-shared/utils';
import { format } from 'fecha';
import { ProductKindInReport } from './product-kind-in-report';

export interface SalesByProductsParameters {
    active?: boolean;
    convertToPln: boolean;
    dateFrom: Date;
    dateTo: Date;
    disposableProductKind?: boolean;
    noProductGroup?: boolean;
    omitInvoiceIssuedToReceipt: boolean;
    productKinds: ProductKindInReport[];
    productGroupId?: string;
    search: string;
}

export interface SalesByProductsModel {
    baseCurrencyGross: number;
    baseCurrencyId: string;
    baseCurrencyNet: number;
    baseCurrencyVat: number;
    currencyId: string;
    gross: number;
    measureUnitId: number;
    name: string;
    net: number;
    productId?: number;
    productGroupId: string;
    quantity: number;
    vat: number;
}

interface SalesByProductsInternalItem {
    baseCurrencyGross: number;
    baseCurrencyId: string;
    baseCurrencyNet: number;
    baseCurrencyVat: number;
    currencyId: string;
    gross: number;
    measureUnitId: number;
    name: string;
    net: number;
    productGroupId: string;
    productId: number;
    quantity: number;
    vat: number;
}

export class SalesByProductsCollectionQuery extends Query<SalesByProductsModel[]> {
    public constructor(public readonly parameters: SalesByProductsParameters) {
        super();
    }
}

export class SalesByProductsCollectionQueryHandlerBase implements QueryHandler<SalesByProductsCollectionQuery, SalesByProductsModel[]> {
    private static Url = TaggedUrl.join('salesByProducts', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(query: SalesByProductsCollectionQuery): Promise<SalesByProductsModel[]> {
        const { data } = await this.http.get<SalesByProductsInternalItem[]>(SalesByProductsCollectionQueryHandlerBase.Url, {
            params: {
                ...query.parameters,
                dateFrom: query.parameters.dateFrom && format(query.parameters.dateFrom, DataFormats.date.webApi),
                dateTo: query.parameters.dateTo && format(query.parameters.dateTo, DataFormats.date.webApi)
            },
            timeout: 3 * MS_PER_MINUTE
        });
        return data.map(item => ({
            baseCurrencyGross: item.baseCurrencyGross,
            baseCurrencyId: item.baseCurrencyId,
            baseCurrencyNet: item.baseCurrencyNet,
            baseCurrencyVat: item.baseCurrencyVat,
            currencyId: item.currencyId,
            gross: item.gross,
            measureUnitId: item.measureUnitId,
            name: item.name,
            net: item.net,
            productGroupId: item.productGroupId,
            productId: item.productId,
            quantity: item.quantity,
            vat: item.vat
        }));
    }
}
